import { useAppSelector } from 'universal-scripts';

export const useIsWidget = () => {
	const widget = useAppSelector((s) => s.widget);

	return widget;
};
